import { render, staticRenderFns } from "./payment-result-subscription-card.vue?vue&type=template&id=ecc3b542&scoped=true&"
import script from "./payment-result-subscription-card.vue?vue&type=script&lang=ts&"
export * from "./payment-result-subscription-card.vue?vue&type=script&lang=ts&"
import style0 from "./payment-result-subscription-card.vue?vue&type=style&index=0&id=ecc3b542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc3b542",
  null
  
)

export default component.exports